import { cn } from "@/lib/utils";
import { PathIcon } from "./path-icon";
import { PathContent } from "./path-content";
import { PathVerticalLines } from "./path-vertical-lines";
import { StepsList } from "./steps-list";
import { usePathStatus } from "./use-path-status";

interface RoadmapNavigationPathProps {
  path: RoadmapPathVM;
  paths: RoadmapPathVM[];
  expandedPaths: Set<number>;
  onTogglePath: (index: number) => void;
  activePathId: number | null;
  activeStep?: RoadmapStepPreviewVM;
  specialization: RoadmapVM;
  isLastPath: boolean;
  isFirstPath: boolean;
  showSteps?: boolean;
  tokenQuery?: string;
  previewPathId?: number | null;
}

export const RoadmapNavigationPath = ({
  path,
  paths,
  expandedPaths,
  onTogglePath,
  activePathId,
  activeStep,
  specialization,
  isLastPath,
  isFirstPath,
  showSteps = true,
  tokenQuery,
  previewPathId,
}: RoadmapNavigationPathProps) => {
  const globalPathIndex = paths.findIndex((p) => p.id === path.id);
  const isExpanded = expandedPaths.has(globalPathIndex);
  const isPreviewPath = previewPathId === path.id;
  const {
    isPathHidden: rawIsPathHidden,
    totalSteps,
    isPathCompleted,
    isPathInProgress,
    isPathActive,
  } = usePathStatus({ path, activePathId });
  const isPathHidden = rawIsPathHidden && !isPreviewPath && !isPathActive;

  return (
    <div className="relative flex flex-col">
      <button
        onClick={() => onTogglePath(globalPathIndex)}
        className={cn(
          "group relative z-10 flex w-full items-start gap-4 px-5 pt-3 pb-1 text-left",
          !isPathHidden && "cursor-pointer",
        )}
      >
        <PathVerticalLines
          isHidden={isPathHidden}
          isFirstPath={isFirstPath}
          isLastPath={isLastPath}
          isExpanded={isExpanded}
        />
        {/* Path Icon Container (Masks the line) */}
        <div className="z-1 flex w-6 shrink-0 justify-center py-1">
          <PathIcon
            isPathCompleted={isPathCompleted}
            isPathActive={isPathActive}
            isPathInProgress={isPathInProgress}
            isPathHidden={isPathHidden}
          />
        </div>

        {/* Path Content */}
        <PathContent
          title={path.title}
          isPathHidden={isPathHidden}
          totalSteps={totalSteps}
          isExpanded={isExpanded}
          showChevron={true}
        />
      </button>

      {/* Steps List */}
      {showSteps && !isPathHidden && isExpanded && (
        <StepsList
          steps={path.steps}
          activeStep={activeStep}
          specialization={specialization}
          isExpanded={isExpanded}
          isLastPath={isLastPath}
          tokenQuery={tokenQuery}
        />
      )}
    </div>
  );
};
